import React from "react";
import { onSnapshot, doc } from "firebase/firestore";
import { colAt } from "../pages/Community/components/fbPath";

const profileCache = new Map();

function subscribeProfile(uid, onChange) {
  if (!uid) return () => {};
  let entry = profileCache.get(uid);
  if (!entry) {
    entry = { data: null, subs: new Set(), unsub: null };
    profileCache.set(uid, entry);
    const ref = doc(colAt("public_profiles"), uid);
    entry.unsub = onSnapshot(ref, (snap) => {
      entry.data = snap.exists() ? snap.data() : null;
      entry.subs.forEach((fn) => fn(entry.data));
    });
  }
  entry.subs.add(onChange);
  if (entry.data !== null) onChange(entry.data);
  return () => {
    const e = profileCache.get(uid);
    if (!e) return;
    e.subs.delete(onChange);
    if (e.subs.size === 0 && e.unsub) {
      e.unsub();
      profileCache.delete(uid);
    }
  };
}

function useUserProfile(uid) {
  const [profile, setProfile] = React.useState(null);
  React.useEffect(() => subscribeProfile(uid, setProfile), [uid]);
  return profile;
}

export function UserName({ userId, fallback = "Player" }) {
  const p = useUserProfile(userId);
  return <>{p?.displayName || fallback}</>;
}

export function UserAvatar({ userId, className = "msn-reply__avatar" }) {
  const p = useUserProfile(userId);
  const src = p?.photoURL || "/avatar.svg";
  return <img className={className} src={src} alt="" />;
}
